<script setup lang="ts">
import { computed } from 'vue-demi';

interface Props {
    atSearchTab?: boolean;
}

const props = withDefaults(defineProps<Props>(), {});

const searchStyle = computed(() => props.atSearchTab && 'at-search');
</script>

<template>
    <div
        v-if="$slots.mainTitleTop || $slots.mainTitle || $slots.mainTitleBottom"
        class="page-titles"
        :class="searchStyle"
    >
        <div class="main-title-top">
            <slot name="mainTitleTop" />
        </div>
        <div class="main-title">
            <slot name="mainTitle" />
        </div>
        <div class="main-title-bottom">
            <slot name="mainTitleBottom" />
        </div>
        <slot name="main"></slot>
    </div>
</template>

<style lang="scss" scoped>
@import '../var.scss';

.page-titles {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    &.at-search {
        margin-top: $expand-vertical-gap-search;
    }
}

.main-title-top {
    margin-top: $main-title-top-gap;
    width: 100%;
    height: $main-title-top-height;
    text-align: center;
    :deep(img) {
        height: 100%;
        vertical-align: top;
    }
}

.main-title {
    margin-top: $main-title-gap;
    height: $main-title-height;
    width: 100%;
    text-align: center;
    :deep(img) {
        height: 100%;
        vertical-align: top;
    }
}

.main-title-bottom {
    margin-top: $main-title-gap;
    font-size: $main-title-bottom-font-size;
    line-height: $main-title-bottom-line-height;
}
</style>
